/**
 * Emits the design tokens as CSS custom properties (--cp-*) so static CSS
 * files can consume the same single source of truth as the Ant theme config.
 */
import { getDesignTokens, type ColorMode, type DesignTokens } from './tokens';

const kebab = (s: string): string => s.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`);

interface FlatVars {
  [key: string]: string | number;
}

function flatten(input: unknown, prefix: string, out: FlatVars): void {
  if (input === null || input === undefined) {
    return;
  }
  if (typeof input === 'object' && !Array.isArray(input)) {
    for (const [key, value] of Object.entries(input as Record<string, unknown>)) {
      flatten(value, prefix ? `${prefix}-${kebab(key)}` : kebab(key), out);
    }
    return;
  }
  out[prefix] = input as string | number;
}

export function buildCssVars(tokens: DesignTokens): FlatVars {
  const vars: FlatVars = {};
  flatten(tokens, 'cp', vars);
  return vars;
}

export function applyDesignTokens(mode: ColorMode): void {
  const tokens = getDesignTokens(mode);
  const vars = buildCssVars(tokens);
  const root = document.documentElement;
  for (const [name, value] of Object.entries(vars)) {
    root.style.setProperty(`--${name}`, String(value));
  }
}
